import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Control = () => {
    document.title = "Yoxlama";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Yoxlama", value: "/settings/control", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Yoxlama</h2>
                    <p>
                        Əməliyyatlar nəticəsində məhsulun maya dəyərinin hesablanması zamanı istifadəçi tərəfindən icra olunan ardıcıllıq xətaları barədə
                        istifadəçiyə məlumat vermək üçün və bu xətaları aradan qaldırmaq üçün nəzərdə tutulub.
                        <br />
                        Ayarlar səhifəsində <mark>Yoxlama</mark> seçimi edildikdən sonra açılan pəncərədə xətalı məhsullar göstərilir. Məhsulun adının üzərinə
                        klik olunduqda isə, açılan pəncərədə həmin məhsul ilə bağlı əməliyyatlar əks olunur. Xətanın baş verdiyi əməliyyatlar sarı rəng ilə
                        göstərilir. Növbəti addım olaraq, <mark>sarı</mark> rəngdə göstərilən əməliyyatın üzərinə klik edərək açılmış pəncərdə dəyişiklik olunur
                        və <SaveButton /> düyməsi sıxılır.
                        <br />
                        Nümunədə xətalı sənəd ilə bağlı əməliyyat ardıcıllığı göstərilib.
                    </p>
                    <img src="/images/settings/control.gif" alt="Yoxlama" />
                </article>
            </div>
        </div>
    );
};
